import { render, staticRenderFns } from "./SignUpRegisterForm.vue?vue&type=template&id=2203915a&scoped=true"
import script from "./SignUpRegisterForm.vue?vue&type=script&lang=js"
export * from "./SignUpRegisterForm.vue?vue&type=script&lang=js"
import style0 from "./SignUpRegisterForm.vue?vue&type=style&index=0&id=2203915a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203915a",
  null
  
)

export default component.exports